import { createIcon } from "@chakra-ui/icons";

export const PivotIcon = createIcon({
  displayName: "PivotIcon",
  viewBox: "0 0 20 20",
  path: (
    <>
      <path
        d="M18.0002 1.49974H7.50015C7.17798 1.49974 6.91681 1.76091 6.91681 2.08308V5.08308C6.91681 5.40525 7.17798 5.66641 7.50015 5.66641H18.0002C18.3223 5.66641 18.5835 5.40525 18.5835 5.08308V2.08308C18.5835 1.76091 18.3223 1.49974 18.0002 1.49974Z"
        fill="currentColor"
      />
      <path
        d="M1.50024 7.49942V17.9995C1.50024 18.3216 1.76141 18.5828 2.08358 18.5828H5.08358C5.40575 18.5828 5.66691 18.3216 5.66691 17.9995V7.49942C5.66691 7.17725 5.40575 6.91608 5.08358 6.91608H2.08358C1.76141 6.91608 1.50024 7.17725 1.50024 7.49942Z"
        fill="currentColor"
      />
      <path
        d="M1.50024 2.08242V5.08242C1.50024 5.40459 1.76141 5.66575 2.08358 5.66575H5.08358C5.40575 5.66575 5.66691 5.40459 5.66691 5.08242V2.08242C5.66691 1.76025 5.40575 1.49908 5.08358 1.49908H2.08358C1.76141 1.49908 1.50024 1.76025 1.50024 2.08242Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    w: "20px",
    h: "20px",
  },
});
